import { BaseTextMergeContainerEditor } from "./BaseTextMergeContainerEditor";
import StyleOutlinedIcon from "@mui/icons-material/StyleOutlined";
import { StyleElement } from "../../../rule-engine-core/TextMerge/Elements/Text/StyleElement";
import { TextMergeEditContext } from "../../../rule-engine-core/TextMerge/TextMergeEditContext";
import React, { useState } from "react";
import { TextEditorRegistration } from "../../Utilities/RegisterTextEditor";
import { ObserveState } from "../../../CommonUI/StateManagement/ObserveState";
import { Box, Link } from "@mui/material";
import { BaseTextMergeContainerElement } from "../../../rule-engine-core/TextMerge/Elements/BaseTextMergeContainerElement";

export class TextMergeStyleEditor extends BaseTextMergeContainerEditor<StyleElement> {
    getIcon(): JSX.Element {
        return <StyleOutlinedIcon />;
    }

    override renderAbove(
        element: BaseTextMergeContainerElement,
        context: TextMergeEditContext,
    ): JSX.Element | undefined {
        return (
            <Box
                marginLeft={"30px"}
                paddingBottom={"10px"}
                display={"flex"}
                justifyContent={"end"}
            >
                <Box paddingRight={"10px"}>
                    <StyleSwitch element={this.editorData!} />
                </Box>
                {super.renderAbove(element, context)}
            </Box>
        );
    }

    override renderContent(editContext: TextMergeEditContext, styles: object): React.ReactNode {
        if (this.editorData?.newParagraph === true) {
            return (
                <p style={styles}>
                    {this.editorData?.elements.map((e) => {
                        let editor = TextEditorRegistration.getExpressionByTypeName(e.__type)?.create(e);
                        return (
                            <ObserveState
                                listenTo={e}
                                control={() => {
                                    return editor?.renderDisplay(e, editContext);
                                }}
                            />
                        );
                    })}
                </p>
            );
        } else {
            return (
                <span style={styles}>
                    {this.editorData?.elements.map((e) => {
                        let editor = TextEditorRegistration.getExpressionByTypeName(e.__type)?.create(e);
                        return (
                            <ObserveState
                                listenTo={e}
                                control={() => {
                                    return editor?.renderDisplay(e, editContext);
                                }}
                            />
                        );
                    })}
                </span>
            );
        }
    }
}

function StyleSwitch(props: { element: StyleElement }) {
    let [isParagraph, setIsParagraph] = useState<boolean>(props.element.newParagraph);
    if (isParagraph) {
        return (
            <Link
                onClick={() => {
                    setIsParagraph(false);
                    props.element.newParagraph = false;
                }}
            >
                New Paragraph [switch]
            </Link>
        );
    } else {
        return (
            <Link
                onClick={() => {
                    setIsParagraph(true);
                    props.element.newParagraph = true;
                }}
            >
                Inline [switch]
            </Link>
        );
    }
}
